module.exports = __webpack_public_path__ + "assets/TaskCard.b5bdda68bdd0a83937ca0feb30e4006a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/levels/TaskCard.svg
// module id = 865
// module chunks = 0